export default "__VITE_ASSET__CxY$b7Np__"